











































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Tabs, TabSettingName } from '@/constants/appSettings'
import dayjs from 'dayjs'
import { SynchronizedStorage } from '@/synchronizedStorage'
import { isCordovaEnvironment } from '@/utils/cordova'
import { reloadApp } from '@/utils'

@Component({
  components: {
    OnlineStatusInput: () => import('@/components/common/OnlineStatusInput.vue')
  }
})
export default class Header extends Vue {
  @Prop({ default: false })
  blackout!: boolean

  $store!: ExStore
  tooltipShow = false

  get tabSettings() {
    return this.$store.getters['appSettings/displayTabs']
  }

  get patientInfoLink() {
    if (!this.patient) return {}
    return {
      name:
        Tabs[
          this.tabSettings.filter(tab => tab.isActive)[0].name as TabSettingName
        ].routeName,
      params: { patientId: this.patient.id }
    }
  }

  get patient() {
    return this.$store.getters['patient/currentPatient']
  }

  get patientName() {
    if (!this.patient) return ''
    return `${this.patient.lastName}${this.patient.firstName}（${this.patient.age}歳）`
  }

  get calling() {
    //FIXME: dummy
    return false
  }

  get isLogin() {
    return this.$store.getters['user/isLogin']
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get displayIsLoggedIn() {
    return this.isLogin ? 'ログイン中' : 'ログアウト中'
  }

  get userDisplayName() {
    const { lastName, firstName } = this.userInfo
    return lastName + firstName
  }

  get unreadMessages() {
    return this.$store.getters['message/unreadMessages']
  }

  get missedCallLog() {
    return this.$store.getters['call/missedCallLog']
  }

  get hasUncheckedCallLog() {
    const lastCheckedTime = this.$store.getters['call/lastCheckedTime'] || 0
    return this.missedCallLog.some(
      ({ registeredDatetime }) =>
        dayjs(registeredDatetime).unix() > lastCheckedTime
    )
  }

  get isCordovaEnvironment() {
    return isCordovaEnvironment
  }

  async logout() {
    try {
      await this.$store.dispatch('user/logout')
      reloadApp()
    } catch (e) {
      console.error(e)
    }
  }

  async beforeCreate() {
    const time = await SynchronizedStorage.MessageLastCheckedTime.get()
    this.$store.commit('call/setLastCheckedTime', Number(time))
  }

  showCallModal() {
    this.$store.dispatch('call/displayUserselectModal', true)
  }

  showMessageModal() {
    this.$store.dispatch('message/displayMessageModal', true)
  }

  handleMouseOverTooltip() {
    this.tooltipShow = true
  }

  handleMouseLeaveTooltip() {
    this.tooltipShow = false
  }
}
